require('./bootstrap');
require('./script');
require('./custom');

import CryptoRate from './components/crypto-rate';

window.Swal       = global.Swal = require('sweetalert2');
global.vueModules = {
    CryptoRate,
};
